import { BaseInput } from "shared/components/forms/BaseInput";

export const DateWidget = () => {
  return (
    <div className="flex items-end">
      <BaseInput
        id="month"
        label="Month"
        className="w-[80px]"
        placeholder="MM"
        hideOptional
        readOnly
        value=""
        onChange={() => {}}
      />
      <i className="text-[40px] w-[52px] text-center translate-y-1">/</i>
      <BaseInput
        id="day"
        label="Day"
        className="w-[80px]"
        placeholder="DD"
        hideOptional
        readOnly
        value=""
        onChange={() => {}}
      />
      <i className="text-[40px] w-[52px] text-center translate-y-1">/</i>{" "}
      <BaseInput
        id="year"
        label="Year"
        className="w-[100px]"
        placeholder="YYYY"
        hideOptional
        readOnly
        value=""
        onChange={() => {}}
      />
    </div>
  );
};
